import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
const taskVuex = createNamespacedHelpers("task");
import vailcode from "@utils/errcode";
export default {
  name: "rewards",
  computed: {
    ...userVuex.mapState(["isLogin"]),
    ...taskVuex.mapState(["taskInfo"])
  },
  watch: {
    isLogin: {
      async handler(bool) {
        this.initFn();
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      dailyList: [],
      dailyDistance: 0,
      dailyTodayItem: null,
      dailyLastTimer: null
    };
  },
  methods: {
    ...taskVuex.mapActions(["getSignDailyTask", "signDailyIn"]),
    async initFn() {
      await this.setSignDailyTask();
    },
    async setSignDailyTask() {
      let res = await this.getSignDailyTask({
        type: 1,
        refresh: 1
      });
      if (!res) {
        return;
      }
      res.steps.map(item => {
        if (item.today) {
          this.dailyTodayItem = item;
        }
      });
      this.dailyList = res.steps;
      console.log(" this.dailyList", this.dailyList);
      if (!this.dailyTodayItem.completed) {
        this.$toasted.clear();
        this.$toasted.success("Sign in successfully!");
        res = await this.signDailyIn({
          type: 1,
          multiple: 0
        });
        if (!res) {
          return;
        }
        this.dailyList = res.steps;
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.taskInfo.popCoinAnim.userInfo = res.user;
        this.taskInfo.popCoinAnim.reward = this.dailyTodayItem.coins;
        this.taskInfo.popCoinAnim.show = true;
      }
      this.dailyDistance = res.tomorrow_distance;
      this.signCountDown();
    },
    signCountDown() {
      clearTimeout(this.dailyLastTimer);
      if (this.dailyDistance > 0) {
        this.dailyDistance--;
      }
      if (this.dailyDistance <= 0) {
        clearTimeout(this.dailyLastTimer);
        this.setSignDailyTask();
        return;
      }
      setTimeout(() => {
        this.signCountDown();
      }, 1000);
    }
  }
};